import {
    faTag,
    faCommentDollar,
    faCube,
    faAlarmClock,
    faThumbsDown,
    faTruck,
    faCartCircleCheck,
    faTruckClock,
} from '@fortawesome/pro-regular-svg-icons';

import { withIcon } from '../../../core/components/Icon.tsx';

const DefaultCardIcon = withIcon(faTag);

const CATEGORY_ICON_BY_NAME: Record<string, ReturnType<typeof withIcon>> = {
    'price request': withIcon(faCommentDollar),
    'product specification': withIcon(faCube),
    availability: withIcon(faAlarmClock),
    'delivery complaint': withIcon(faThumbsDown),
    'delivery date': withIcon(faTruck),
    'order confirmation': withIcon(faCartCircleCheck),
    'tracking link': withIcon(faTruckClock),
};

export const cardIconFor = (name: string) => CATEGORY_ICON_BY_NAME[name.trim().toLowerCase()] ?? DefaultCardIcon;
